import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_donvitinh, Lists_phongban, Lists_loaitaisan, Lists_loaikhoan, Lists_tieumuc, Lists_nguonhinhthanh, Lists_xuatxu, Lists_nguonkinhphi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-taisanedit',
  templateUrl: './taisanedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./taisanedit.component.scss'],
    providers: [ListService, Repository]
})


export class taisaneditComponent implements OnInit {

    @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('slLoaiTaiSan', { static: false }) slLoaiTaiSan: any;
  @ViewChild('slNuocSanXuat', { static: false }) slNuocSanXuat: any;
  @ViewChild('slPhongBan', { static: false }) slPhongBan: any;
  @ViewChild('slNguonHT', { static: false }) slNguonHT: any;
  @ViewChild('slLoaiKhoan', { static: false }) slLoaiKhoan: any;
  @ViewChild('slTieuMuc', { static: false }) slTieuMuc: any;
  @ViewChild('slDVT', { static: false }) slDVT: any;
  @ViewChild('slCapTren', { static: false }) slCapTren: any;
  @ViewChild('slTaiKhoanTaiSan', { static: false }) slTaiKhoanTaiSan: any;
  @ViewChild('slTaiKhoanNoHM', { static: false }) slTaiKhoanNoHM: any;
  @ViewChild('slTaiKhoanCoHM', { static: false }) slTaiKhoanCoHM: any;
  @ViewChild('slTaiKhoanChiPhi', { static: false }) slTaiKhoanChiPhi: any;
  @ViewChild('slTaiKhoanKhauHao', { static: false }) slTaiKhoanKhauHao: any;
  @ViewChild('dateGhiTang', { static: false }) dateGhiTang: any;
  @ViewChild('dateKH', { static: false }) dateKH: any;


    quyen_them: boolean = false;
    quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_themxuatxu: boolean = false;
    public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  public ngxCurrencyOptions2 = {
    prefix: '',
    thousands: '',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  

  public ngxSLOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 3,
    allowNegative: true
  };
  currentUser: any;
    inputparents: any;
  inputdvts: any;
  inputphongbans: any;
    inputloaitaisans: any;
    inputtaikhoantaisans: any;
    inputtaikhoanchiphis: any;
  inputtaikhoankhauhaos: any;

  inputtaikhoantaisan24s: any;
  inputtaikhoanchiphi24s: any;
  inputtaikhoankhauhao24s: any;

  inputloaikhoans: any;
  inputtieumucs: any;
  inputnguons: any;
  inputnguonkinhphis: any;


  inputphuongphapkhauhaos: any = [
     { Id: 0, Ma_Doi_Tuong: '1', Ten_Doi_Tuong: 'Theo đường thẳng' }
    ,{ Id: 1, Ma_Doi_Tuong: '2', Ten_Doi_Tuong: 'Tỉ lệ khấu hao / năm' }
    ,{ Id: 2, Ma_Doi_Tuong: '3', Ten_Doi_Tuong: 'Định mức khấu hao theo tháng' }
  ];
  inputtrangthaitaisans: any = [
    { Id: 0, Ma_Doi_Tuong: '0', Ten_Doi_Tuong: 'Đang sử dụng' }
    , { Id: 1, Ma_Doi_Tuong: '1', Ten_Doi_Tuong: 'Hỏng' }
  ];
    inputxuatxus: any;
    public ngayghitang: Date = null;
    public ngaykhauhao: Date = null;
    public ngaythoikhauhao: Date = null;
  donviid: any;
  tabselected: number = 1;

    indLoading: boolean = false;    
    doituongSelect: any = { Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:null,Nhom_Doi_Tuong_ID:null,Don_Vi_Id:null,Ma_Ao:null,
      Ngay_Ghi_Tang: null, Ngay_Ghi_TangS: null, Ngay_Khau_Hao: null, Ngay_Khau_HaoS: null, Thoi_Gian_Khau_Hao: null
      , Loai_Tai_San_Id: null, Phong_Ban_Id: null, TK_Tai_San_Id: null, TK_Chi_Phi_Id: null
      , TK_Khau_Hao_Id: null, Phuong_Phap_Khau_Hao: null, Xuat_Xu_Id: null, Nam_San_Xuat: null
      , Don_Vi_Tinh_Id: null, So_Tien: null, Ngay_Thoi_Khau_Hao: null, Ngay_Thoi_Khau_HaoS: null, Ty_Le_KD: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null
      , Nguon_Von_Id: null, Tam_Dung_Khau_Hao: null, La_Tai_San: null, Khau_Hao_Chi_Tiet: null, TK_No_HM: null, TK_Co_HM: null
      , Nguon_Id: null, Nguyen_Gia: null, ChiTiets: [], TK_Tai_San_24_Id: null, TK_No_HM_24: null, TK_Co_HM_24: null
      , TrangThaiTaiSan: null
    };    
    nhomdtid:string=null;


    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
      

    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_TK(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Tai_Khoan.toLowerCase().indexOf(term) > -1 || item.Ten_Tai_Khoan.toLowerCase().indexOf(term) > -1;
  }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string, datadoituong: any){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        this.currentUser = data;
        this.donviid = data.id_don_vi;
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }

        giatri = data.ds_quyen.filter(name => name.id === Lists_xuatxu.id.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_themxuatxu = true;
          else
            this.quyen_themxuatxu = false;
          
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/'+id+'/'+donviid)
        .subscribe(response => {            
            this.inputparents=response;
        });
      this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: 2024, DonViId: this.donviid, UserName: null })
        .subscribe(response => {
          this.inputtaikhoantaisans = response;
          this.inputtaikhoanchiphis = response;
          this.inputtaikhoankhauhaos = response;
        });

      this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: 2025, DonViId: this.donviid, UserName: null })
        .subscribe(response => {
          this.inputtaikhoantaisan24s = response;
          this.inputtaikhoanchiphi24s = response;
          this.inputtaikhoankhauhao24s = response; 
        });

      this.repo.getRequest("api/doituong/getall2/" + Lists_donvitinh.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputdvts = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_phongban.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputphongbans = response;
        });
      this.repo.getRequest("api/doituong/getloaitaisan/" + Lists_loaitaisan.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputloaitaisans = response;
        });
      this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaikhoan.id, MaGiaoDien: '', DonViId: donviid })
        .subscribe(response => {
          this.inputloaikhoans = response;
        });
      this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: donviid })
        .subscribe(response => {
          this.inputtieumucs = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_nguonhinhthanh.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputnguons = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_nguonkinhphi.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputnguonkinhphis = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_xuatxu.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputxuatxus = response;
        });

      var getNow = new Date();
      this.ngayghitang = new Date(getNow.getFullYear(), getNow.getMonth()+1, 1, 0, 0, 0);
      this.ngaykhauhao = new Date(getNow.getFullYear(), getNow.getMonth()+1, 1, 0, 0, 0);
      this.ngaythoikhauhao = null;
     

      this.doituongSelect = {
        Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null, Ghi_Chu: null, Parent: null, Trang_Thai: true, Nhom_Doi_Tuong_ID: nhomdoituongid, Don_Vi_Id: donviid, Ma_Ao: null,
        Ngay_Ghi_Tang: null, Ngay_Ghi_TangS: null, Ngay_Khau_Hao: null, Ngay_Khau_HaoS: null, Thoi_Gian_Khau_Hao: null
        , Loai_Tai_San_Id: null, Phong_Ban_Id: null, TK_Tai_San_Id: null, TK_Chi_Phi_Id: null
        , TK_Khau_Hao_Id: null, Phuong_Phap_Khau_Hao: null, Xuat_Xu_Id: null, Nam_San_Xuat: null
        , Don_Vi_Tinh_Id: null, So_Tien: null, Ngay_Thoi_Khau_Hao: null, Ngay_Thoi_Khau_HaoS: null, So_Luong: null
        , Nguon_Von_Id: null, Tam_Dung_Khau_Hao: null, La_Tai_San: null, Khau_Hao_Chi_Tiet: null, TK_No_HM: null, TK_Co_HM: null, Ty_Le_KD: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null
        , Nguon_Id: null, Nguyen_Gia: null, ChiTiets: [], TK_Tai_San_24_Id: null, TK_No_HM_24: null, TK_Co_HM_24: null
        , TrangThaiTaiSan: null
      };
        
        if(id === null)
        {
          if (datadoituong != null) {
            this.repo.getRequest("api/doituongtaisan/getmodel/" + datadoituong.Id)
              .subscribe(response => {
                console.log(response);
               // this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/' + donviid)
                  .subscribe(response1 => {
                    console.log(response1);
                    this.doituongSelect.Ma_Doi_Tuong = response1;
                  });
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;

                this.doituongSelect.So_Luong = response.So_Luong;
                this.doituongSelect.Ngay_Ghi_Tang = response.Ngay_Ghi_Tang;
                this.doituongSelect.Ngay_Khau_Hao = response.Ngay_Khau_Hao;
                this.doituongSelect.Thoi_Gian_Khau_Hao = response.Thoi_Gian_Khau_Hao;
                this.doituongSelect.Loai_Tai_San_Id = response.Loai_Tai_San_Id;
                this.doituongSelect.Phong_Ban_Id = response.Phong_Ban_Id;
                this.doituongSelect.TK_Tai_San_Id = response.TK_Tai_San_Id;
                this.doituongSelect.TK_Chi_Phi_Id = response.TK_Chi_Phi_Id;
                this.doituongSelect.TK_Khau_Hao_Id = response.TK_Khau_Hao_Id;
                this.doituongSelect.Phuong_Phap_Khau_Hao = response.Phuong_Phap_Khau_Hao;
                this.doituongSelect.Xuat_Xu_Id = response.Xuat_Xu_Id;
                this.doituongSelect.Nam_San_Xuat = response.Nam_San_Xuat;
                this.doituongSelect.Don_Vi_Tinh_Id = response.Don_Vi_Tinh_Id;
                this.doituongSelect.So_Tien = response.So_Tien;
                this.doituongSelect.Nguyen_Gia = response.Nguyen_Gia;
                this.doituongSelect.Ngay_Thoi_Khau_Hao = response.Ngay_Thoi_Khau_Hao;
                this.doituongSelect.Nguon_Von_Id = response.Nguon_Von_Id;
                this.doituongSelect.Tam_Dung_Khau_Hao = response.Tam_Dung_Khau_Hao;
                this.doituongSelect.La_Tai_San = response.La_Tai_San;
                this.doituongSelect.Khau_Hao_Chi_Tiet = response.Khau_Hao_Chi_Tiet;
                this.doituongSelect.TK_No_HM = response.TK_No_HM;
                this.doituongSelect.TK_Co_HM = response.TK_Co_HM;
                this.doituongSelect.Ty_Le_KD = response.Ty_Le_KD;
                this.doituongSelect.Loai_Khoan_Id = response.Loai_Khoan_Id;
                this.doituongSelect.Tieu_Muc_Id = response.Tieu_Muc_Id;
                this.doituongSelect.Nguon_Id = response.Nguon_Id;
                this.doituongSelect.TrangThaiTaiSan = response.TrangThaiTaiSan;

                if (this.doituongSelect.Ngay_Ghi_Tang != null)
                  this.ngayghitang = new Date(this.doituongSelect.Ngay_Ghi_Tang);
                if (this.doituongSelect.Ngay_Khau_Hao != null)
                  this.ngaykhauhao = new Date(this.doituongSelect.Ngay_Khau_Hao);
                if (this.doituongSelect.Ngay_Thoi_Khau_Hao != null)
                  this.ngaythoikhauhao = new Date(this.doituongSelect.Ngay_Thoi_Khau_Hao);

                this.doituongSelect.ChiTiets = response.ChiTiets;

                this.doituongSelect.TK_Tai_San_24_Id = response.TK_Tai_San_24_Id;
                this.doituongSelect.TK_No_HM_24 = response.TK_No_HM_24;
                this.doituongSelect.TK_Co_HM_24 = response.TK_Co_HM_24;

              }); 
          }
          else {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/' + donviid)
              .subscribe(response1 => {
                console.log(response1);
                this.doituongSelect.Ma_Doi_Tuong = response1;
              });
            this.doituongSelect.Trang_Thai = true;
            this.doituongSelect.La_Tai_San = true;
            this.doituongSelect.Khau_Hao_Chi_Tiet = true;
            this.doituongSelect.Tam_Dung_Khau_Hao = false;
            this.doituongSelect.So_Luong = 1;
          }
        }
        else {
            console.log(id);
          this.repo.getRequest("api/doituongtaisan/getmodel/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;

              this.doituongSelect.So_Luong = response.So_Luong;
              this.doituongSelect.Ngay_Ghi_Tang = response.Ngay_Ghi_Tang;
              this.doituongSelect.Ngay_Khau_Hao = response.Ngay_Khau_Hao;
              this.doituongSelect.Thoi_Gian_Khau_Hao = response.Thoi_Gian_Khau_Hao;
              this.doituongSelect.Loai_Tai_San_Id = response.Loai_Tai_San_Id;
              this.doituongSelect.Phong_Ban_Id = response.Phong_Ban_Id;
              this.doituongSelect.TK_Tai_San_Id = response.TK_Tai_San_Id;
              this.doituongSelect.TK_Chi_Phi_Id = response.TK_Chi_Phi_Id;
              this.doituongSelect.TK_Khau_Hao_Id = response.TK_Khau_Hao_Id;
              this.doituongSelect.Phuong_Phap_Khau_Hao = response.Phuong_Phap_Khau_Hao;
              this.doituongSelect.Xuat_Xu_Id = response.Xuat_Xu_Id;
              this.doituongSelect.Nam_San_Xuat = response.Nam_San_Xuat;
              this.doituongSelect.Don_Vi_Tinh_Id = response.Don_Vi_Tinh_Id;
              this.doituongSelect.So_Tien = response.So_Tien;
              this.doituongSelect.Nguyen_Gia = response.Nguyen_Gia;
              this.doituongSelect.Ngay_Thoi_Khau_Hao = response.Ngay_Thoi_Khau_Hao;
              this.doituongSelect.Nguon_Von_Id = response.Nguon_Von_Id;
              this.doituongSelect.Tam_Dung_Khau_Hao = response.Tam_Dung_Khau_Hao;
              this.doituongSelect.La_Tai_San = response.La_Tai_San;
              this.doituongSelect.Khau_Hao_Chi_Tiet = response.Khau_Hao_Chi_Tiet;
              this.doituongSelect.TK_No_HM = response.TK_No_HM;
              this.doituongSelect.TK_Co_HM = response.TK_Co_HM;
              this.doituongSelect.Ty_Le_KD = response.Ty_Le_KD;
              this.doituongSelect.Loai_Khoan_Id = response.Loai_Khoan_Id;
              this.doituongSelect.Tieu_Muc_Id = response.Tieu_Muc_Id;
              this.doituongSelect.Nguon_Id = response.Nguon_Id;
              this.doituongSelect.TrangThaiTaiSan = response.TrangThaiTaiSan;
              
              if (this.doituongSelect.Ngay_Ghi_Tang != null)
                this.ngayghitang = new Date(this.doituongSelect.Ngay_Ghi_Tang);
              if (this.doituongSelect.Ngay_Khau_Hao != null)
                this.ngaykhauhao = new Date(this.doituongSelect.Ngay_Khau_Hao);
              if (this.doituongSelect.Ngay_Thoi_Khau_Hao != null)
                this.ngaythoikhauhao = new Date(this.doituongSelect.Ngay_Thoi_Khau_Hao);

              this.doituongSelect.ChiTiets = response.ChiTiets;

              this.doituongSelect.TK_Tai_San_24_Id = response.TK_Tai_San_24_Id;
              this.doituongSelect.TK_No_HM_24 = response.TK_No_HM_24;
              this.doituongSelect.TK_Co_HM_24 = response.TK_Co_HM_24;


            }); 
        }
        
       
    }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {


      setTimeout(() => {
        this.dateGhiTang.focus();
      }, 100);
    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }
   
  }
    keyTenPress(event: any) { 
        if (event.which === 13) {
          this.slLoaiTaiSan.focus();
            event.preventDefault();
          }
  }
  keyLoaiTSPress(event: any) {
    if (event.which === 13) {
      this.slPhongBan.focus();
      event.preventDefault();
    }
  }
  keyPhongBanPress(event: any) {
    if (event.which === 13) {
      this.slNguonHT.focus();
      event.preventDefault();
    }
  }
  keyNguonPress(event: any) {
    if (event.which === 13) {
      this.slLoaiKhoan.focus();
      event.preventDefault();
    }
  }
  keyLoaiKhoanPress(event: any) {
    if (event.which === 13) {
      this.slTieuMuc.focus();
      event.preventDefault();
    }
  }
  keyTieuMucPress(event: any) {
    if (event.which === 13) {
      this.slDVT.focus();
      event.preventDefault();
    }
  }
  keyDvtPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  keyNgayGTPress(event: any) {
    if (event.which === 13) {
      this.dateKH.focus();
      event.preventDefault();
    }
  }
  keyNgayKHPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanTaiSan.focus();
      event.preventDefault();
    }
  }
  keyGiaTriHMPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanNoHM.focus();
      event.preventDefault();
    }
  }
  keyTKNoHMPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanCoHM.focus();
      event.preventDefault();
    }
  }
  keyTKCoHMPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanChiPhi.focus();
      event.preventDefault();
    }
  }
  keyTKNoKHPress(event: any) {
    if (event.which === 13) {
      this.slTaiKhoanKhauHao.focus();
      event.preventDefault();
    }
  }
  onDoiTuongNguonChange($event) {
    if (typeof $event === "undefined") {
      //this.doituongSelect.TK_No_HM = null;
    }
    else {
      this.repo.postRequest("api/doituongtaisan/Get_TKNo_HM", { Id: $event.Id })
        .subscribe(response => {
          if (response != null && response.match('-')) {
            this.doituongSelect.TK_No_HM = response;
          }
        });
      this.repo.postRequest("api/doituongtaisan/Get_TKNo_HM_24", { Id: $event.Id })
        .subscribe(response => {
          if (response != null && response.match('-')) {
            this.doituongSelect.TK_No_HM_24 = response;
          }
        });
    }
  }
  onDoiTuongChange($event) {
    console.log($event);
    if (typeof $event === "undefined") {
     // this.doituongSelect.Nguon_Id = null;
      this.doituongSelect.Loai_Khoan_Id = null;
      this.doituongSelect.Tieu_Muc_Id = null;
      this.doituongSelect.TK_Tai_San_Id = null;
      this.doituongSelect.Thoi_Gian_Khau_Hao = null;
      this.doituongSelect.TK_No_HM = null;
      this.doituongSelect.TK_Co_HM = null;
      this.doituongSelect.TK_Chi_Phi_Id = null;
      this.doituongSelect.TK_Khau_Hao_Id = null;
       
      this.doituongSelect.TK_Tai_San_24_Id = null;
      this.doituongSelect.TK_No_HM_24 = null;
      this.doituongSelect.TK_Co_HM_24 = null;
    }
    else
    {
      //this.doituongSelect.Nguon_Id = $event.Nguon_Id;
      this.doituongSelect.Loai_Khoan_Id = $event.Loai_Khoan_Id;
      this.doituongSelect.Tieu_Muc_Id = $event.Tieu_Muc_Id;
      this.doituongSelect.Thoi_Gian_Khau_Hao = $event.Thoi_Gian_Khau_Hao;

      this.doituongSelect.TK_Tai_San_Id = $event.TK_Tai_San_Id;
      this.doituongSelect.TK_Tai_San_24_Id = $event.TK_Tai_San_24_Id;
      //if (this.doituongSelect.TK_No_HM == null) {
        
      //}
      if (this.doituongSelect.Nguon_Id !== null) {
        this.repo.postRequest("api/doituongtaisan/Get_TKNo_HM", { Id: this.doituongSelect.Nguon_Id })
          .subscribe(response => {
            if (response != null && response.match('-')) {
              this.doituongSelect.TK_No_HM = response;
            }
          });

        this.repo.postRequest("api/doituongtaisan/Get_TKNo_HM_24", { Id: this.doituongSelect.Nguon_Id })
          .subscribe(response => {
            if (response != null && response.match('-')) {
              this.doituongSelect.TK_No_HM_24 = response;
            }
          });

      }
      else {
        this.doituongSelect.TK_No_HM = $event.TK_No_HM;
        this.doituongSelect.TK_No_HM_24 = $event.TK_No_HM_24;
      }

      if (this.doituongSelect.TK_Co_HM == null) {
        this.doituongSelect.TK_Co_HM = $event.TK_Co_HM;
        this.doituongSelect.TK_Co_HM_24 = $event.TK_Co_HM_24;
      }
      this.doituongSelect.TK_Chi_Phi_Id = $event.TK_Chi_Phi_Id;
      this.doituongSelect.TK_Khau_Hao_Id = $event.TK_Khau_Hao_Id;

    }
      
  }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      if (this.doituongSelect.Thoi_Gian_Khau_Hao == null) {
        swal('Lỗi!', 'Vui lòng nhập thời gian khấu hao!.', 'error');
        return;
      }
      //if (this.doituongSelect.Thoi_Gian_Khau_Hao == null || this.doituongSelect.Thoi_Gian_Khau_Hao == 0) {
      //  swal('Lỗi!', 'Vui lòng nhập thời gian khấu hao!.', 'error');
      //  return;
      //}
      if (this.doituongSelect.Ty_Le_KD !== null && parseInt(this.doituongSelect.Ty_Le_KD, 10)  > 100) {
        swal('Lỗi!', 'Tỷ lệ sản xuất kinh doanh không hợp lệ!.', 'error');
        return;
      }
      if (this.doituongSelect.TK_No_HM_24 == null) {
        swal('Lỗi!', 'Vui lòng nhập tài khoản nợ hao mòn!.', 'error');
        return;
      }
      if (this.doituongSelect.TK_Co_HM_24 == null) {
        swal('Lỗi!', 'Vui lòng nhập tài khoản có hao mòn!.', 'error');
        return;
      }
      //if (this.doituongSelect.TK_Chi_Phi_Id == null) {
      //  swal('Lỗi!', 'Vui lòng nhập tài khoản nợ khấu hao!.', 'error');
      //  return;
      //}
      //if (this.doituongSelect.TK_Khau_Hao_Id == null) {
      //  swal('Lỗi!', 'Vui lòng nhập tài khoản có khấu hao!.', 'error');
      //  return;
      //}

      if (this.ngayghitang != null)
        this.doituongSelect.Ngay_Ghi_TangS = this.ngayghitang.getDate() + '/' + (this.ngayghitang.getMonth() + 1) + '/' + this.ngayghitang.getFullYear();
      if (this.ngaykhauhao != null)
        this.doituongSelect.Ngay_Khau_HaoS = this.ngaykhauhao.getDate() + '/' + (this.ngaykhauhao.getMonth() + 1) + '/' + this.ngaykhauhao.getFullYear();
      if (this.ngaythoikhauhao != null)
        this.doituongSelect.Ngay_Thoi_Khau_HaoS = this.ngaythoikhauhao.getDate() + '/' + (this.ngaythoikhauhao.getMonth() + 1) + '/' + this.ngaythoikhauhao.getFullYear();

      this.repo.postRequest("api/doituongtaisan/addorupdate",this.doituongSelect)
            .subscribe(response => {  
                console.log(response);
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent) {

    this.comboSeleted = cobo;
    cobo.close();
    this.doituongchungedit.loadDataInit(Lists_xuatxu.id, null, this.donviid);
    this.mdDoiTuongChung.open();
  }
   saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();

    this.inputxuatxus.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputxuatxus = this.inputxuatxus.slice();
    this.doituongSelect.Xuat_Xu_Id = doituong.Id;
   
    this.comboSeleted.focus();
  }

  deleterow(index: string, luoi: number) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
            this.doituongSelect.ChiTiets.splice(index, 1);
        }
      });
  }

  RowNewClick() {
    this.AddRowNew(this.doituongSelect.ChiTiets);
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Id: null, Ten: null, DVT: null, So_Luong: null,
        So_Tien: null, Tai_San_Id: null
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Id: null, Ten: null, DVT: null,
        So_Luong: null, So_Tien: null, Tai_San_Id: null
      });

    }

  }
  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {

    //    if (event.which === 13) {
    //  cot = cot + 1;
    //  if (cot > this.maxcot) {
    //    hang = hang + 1;
    //    cot = 1;
    //    this.AddRowNew(this.doituongSelect.ChiTiets);

    //  }
    //  this.setComboFocus(hang, cot, luoi);
    //  event.preventDefault();
    //}
  }

  public export_tscd(kieuin) {
    let khoi = null;
    //if (this.datas == null || this.datas.length == 0) {
    //  swal('Cảnh báo!', "Không có dữ liệu để xuất ra excel.", 'warning');
    //  return;
    //}

    let idbaocao = '4F528C26-490E-4281-A6D8-4F11D054738D';
    let dsdoituong = this.doituongSelect.Id;
    


    $('#loading').show();
    //this.msg = "";
    let data = {
      Id: idbaocao,
      Type: kieuin,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name, Nam: this.currentUser.nam_ke_toan
        , DSID: dsdoituong
      })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          $('#loading').hide();
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "danh_sach_tai_san.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }



  }



}


